import { Icon } from "@blueprintjs/core"
import {
  AllocationLabel,
  AllocationPercentage,
  AllocationRow,
  AllocationValue,
  Card,
  CardTitle,
  TotalExposure,
} from "../Factsheet.styled"
import { AllocationBreakdown } from "../types"
import { formatCurrency, formatPercentage } from "../utils"

interface AllocationCardProps {
  allocation: AllocationBreakdown
  currency?: string | null
}

const ALLOCATION_CONFIG = [
  { key: "equity" as const, label: "Equity", icon: "chart" as const },
  { key: "bond" as const, label: "Bond", icon: "document" as const },
  { key: "monetary" as const, label: "Monetary", icon: "bank-account" as const },
  { key: "cash" as const, label: "Cash", icon: "dollar" as const },
  { key: "alternative" as const, label: "Alternative", icon: "scatter-plot" as const },
  { key: "unknown" as const, label: "Unknown", icon: "help" as const },
]

const AllocationCard = ({ allocation, currency }: AllocationCardProps) => {
  return (
    <Card flexDirection="column">
      <CardTitle>Allocation</CardTitle>
      <TotalExposure>{formatCurrency(allocation.total, currency)}</TotalExposure>
      {ALLOCATION_CONFIG.map(({ key, label, icon }) => {
        const value = allocation[key]
        if (value === 0) return null
        return (
          <AllocationRow key={key} justifyContent="space-between">
            <AllocationLabel>
              <Icon icon={icon} size={16} />
              <span>{label}</span>
            </AllocationLabel>
            <AllocationPercentage>{formatPercentage(value, allocation.total)}</AllocationPercentage>
            <AllocationValue>{formatCurrency(value, currency)}</AllocationValue>
          </AllocationRow>
        )
      })}
    </Card>
  )
}

export default AllocationCard
